import { Button } from '@merels/ui'
import { useTheme } from '../../../../contexts/ThemeContext'

interface NameEntryFormUIProps {
  mateName: string
  error: string
  onNameChange: (name: string) => void
  onSubmit: () => void
}

export function NameEntryFormUI({
  mateName,
  error,
  onNameChange,
  onSubmit
}: NameEntryFormUIProps) {
  const { getAppColor } = useTheme()
  const appColorShades = getAppColor()

  return (
    <div className="max-w-md w-full text-center">
      <div className="flex justify-center mb-4">
        <svg
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          width="120"
          height="120"
        >
          {/* square frame */}
          <path
            d="M15 15 V85 H85 V15 Z"
            stroke={appColorShades.main}
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />

          {/* three filled corner nodes */}
          <g fill={appColorShades.main}>
            <circle cx="15" cy="15" r="8" />
            <circle cx="15" cy="85" r="8" />
            <circle cx="85" cy="85" r="8" />
          </g>

          {/* large circle: between previous two placements */}
          {/* center (75,25) is inside the square but closer to the top-right */}
          <circle
            cx="75"
            cy="25"
            r="21"
            stroke={appColorShades.main}
            strokeWidth="8"
            fill={appColorShades.main}
          />
        </svg>
      </div>
      <h1 
        className="text-6xl font-semibold mb-6 leading-none"
        style={{
          color: appColorShades.main,
          fontFamily: "'MorrisRomanBlack', serif",
        }}
      >
        Merels
      </h1>
      <h2 className="text-base font-bold mb-4 text-primary">Enter Your Name</h2>
      {error && (
        <div className="bg-danger-bg/20 border-2 border-danger-bg/40 text-danger p-4 rounded-lg mb-4 font-bold">
          <strong>Error:</strong> {error}
        </div>
      )}
      <div className="flex flex-col gap-4 items-center">
        <input
          type="text"
          placeholder="Enter your name"
          value={mateName}
          onChange={(e) => onNameChange(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
          className="block w-[240px] max-w-full appearance-none rounded-lg border-2 bg-background px-3 py-3 text-base text-primary shadow-none outline-none ring-0 focus:outline-none focus:ring-0"
          style={{ borderColor: appColorShades.main }}
          autoFocus
        />
        <Button onClick={onSubmit}>
          Continue
        </Button>
      </div>
    </div>
  )
}
